import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { actOptions } from '@store/policies/schedule/utils';
import { getEmails } from '@src/api/schedulePolicies';
import PolicyMultiSelect from './PolicyMultiSelect';
import DateTime from './DateTime';
import Notes from './Notes';
import ActivationRadio from './ActivationRadio';
import Email from './Email';

function useEmailList() {
  const [emailList, setEmailList] = useState([]);

  const fetchEmails = useCallback(async () => {
    const res = await getEmails();
    setEmailList(get(res, ['data', 'emailIds'], []));
  }, []);

  useEffect(() => {
    fetchEmails();
  }, [fetchEmails]);

  return emailList;
}

function Content() {
  const { activationState } = useSelector(formViewSelector);
  const emailList = useEmailList();

  return (
    <div>
      <PolicyMultiSelect />
      <ActivationRadio />
      {activationState === actOptions.schedule && (
        <>
          <DateTime />
          <Email emailList={emailList} />
          <Notes />
        </>
      )}
    </div>
  );
}

export default React.memo(Content);
